<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">{{$t('media.title')}}</div>
        <span class="body-1 greyDarken1--text">{{$t("media.list.subtitle")}}</span>
      </div>
      <v-spacer></v-spacer>
      <CreateFilm v-if="userRoleInCompany >= DEFINES.ROLE_MEMBER"></CreateFilm>
      <v-btn v-if="userRoleInCompany >= DEFINES.ROLE_MEMBER" class="mr-0" @click.stop="initiateImport()" color="secondary">
        <v-icon small class="pr-1">$vuetify.icons.rms_upload</v-icon>
          {{$t('screener.btn.import')}}
      </v-btn>
    </v-card-title>
    <v-card-text>
      <template>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              v-on:keyup.enter="applySearch"
              color="primary"
              append-outer-icon="search"
              :label="$t('screener.search.title')"
              single-line
              hide-details
              @click:clear="clearSearch"
              @click:append-outer="applySearch"
              clear-inner-icon="rms_close"
              clearable
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-if="list.length"
            :headers="table_headers"
            :items="list"
            :pagination.sync="pagination"
            :totalItems="total"
            :rowsPerPageItems="rowsPerPageItems"
          >
            <template v-slot:items="props">
              <tr @click="view(props.item)" :style="{cursor:'pointer'}">
                <td class="text-xs-left subheading" width="5%">{{ props.item.id }}</td>
                <td class="pa-2" width="10%">
                  <v-card height="80px">
                    <div v-if="props.item.thumburls" class="media_file_container">
                      <div
                        :style="{
                                background: 'url('+props.item.thumburls+')' ,
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                bottom: '0',
                                right: '0',
                                backgroundPosition: '50%',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'contain' }"
                      ></div>
                    </div>
                    <v-container
                      v-else
                      bg
                      fill-height
                      grid-list-md
                      text-xs-center
                      class="media_file_container pt-3 "
                    >
                      <v-layout row wrap align-center>
                        <v-flex>
                          <v-icon>$vuetify.icons.rms_image_not_found</v-icon>
                          <div
                            class="caption blue-grey--text"
                          >{{$t('film.list.thumbnails.not_available')}}</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </td>
                <td class="text-xs-left">
                  <div>
                    <div class="subheading">{{ props.item.title[currentLocale] }}</div>
                    <div
                      v-if="props.item.trailer"
                      class="d-inline-block body-1 primary--text pt-1 hover-effect"
                      @click.stop="watchTrailer(props.item)"
                    >{{$t('screener.media.watch_trailer')}}</div>
                  </div>
                </td>
                <td >
                  <v-tooltip top color="greyDarken1">
                    <template v-slot:activator="{on}">
                      <v-chip
                        v-if="props.item.screeners && props.item.screeners.length"
                        v-on="on"
                        :class="props.item.is_external_src ? 'red red--text' : 'success success--text'"
                        small
                        outline
                      >{{ DEFINES.FILM_STREAMING_SOURCES[props.item.is_external_src] }}</v-chip
                      >
                      <v-chip
                        v-else
                        v-on="on"
                        :class="'red red--text'"
                        small
                        outline
                      >{{$t('film.list.thumbnails.not_available')}}</v-chip>

                    </template>
                    <span v-if="props.item.screeners && props.item.screeners.length" class="white--text body-1">{{$t('film.list.thumbnails.not_available')}}</span>
                    <span v-else-if="props.item.is_external_src" class="white--text body-1">{{ $t('screener.media.list.tooltip.insecure_streaming') }}</span>
                    <span v-else class="white--text body-1">{{ $t('screener.media.list.tooltip.secure_streaming') }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-chip
                  small
                  outline
                  :color="!props.item.is_external_src && props.item.encoding_status == DEFINES.ENCODING_STATUS.ENCODED
                  ? 'success--text'
                  : props.item.encoding_status == DEFINES.ENCODING_STATUS.ERROR ? 'error--text' : ''">
                 {{ !props.item.is_external_src && props.item.encoding_status ? props.item.encoding_status : DEFINES.ENCODING_STATUS.NONE }}</v-chip>
                </td>
                <td class="text-xs-left">{{ props.item.length || 0}}</td>
                <td class="text-xs-left">{{ props.item.right_holder_share || '0'}}%</td>
                <td class="text-xs-left">{{ moment(props.item.created_at).format('MMMM Do YYYY') }}</td>
                <td class="text-xs-center">
                  <v-tooltip slot="append" top color="white">
                    <v-btn slot="activator" icon @click.stop="view(props.item)" small dark>
                      <v-icon color="secondary">$vuetify.icons.rms_visibility</v-icon>
                    </v-btn>
                    <span class="greyDarken3--text body-1">{{$t("rms.tooltip.view")}}</span>
                  </v-tooltip>

                  <ConfirmationDialog
                    v-if="userRoleInCompany >= DEFINES.ROLE_ADMIN"
                    :desc="'film.confirmation.delete.description'"
                    :action="getDialogAction(props.item.id,'rms_delete','error')"
                    :headline="'film.confirmation.delete.heading'"
                    :button_type="'icon'"
                  ></ConfirmationDialog>
                </td>
              </tr>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                {{$t('rms.alert.search_not_found', {
                search
                })}}
              </v-alert>
            </template>
          </v-data-table>
          <v-layout v-else row wrap justify-center align-center>
            <v-flex xs12>
              <v-layout column justify-center align-center>
                <v-img src="../../assets/no-data.svg" width="40%" height="100%"></v-img>
                <div class="mt-5 my-3">
                  <div class="headline grey--text text--darken-2" v-if="search">
                  {{$t("assets_manager.not_found.message")}}
                  </div>
                  <div class="headline grey--text text--darken-2" v-else>
                    {{ $t('assets_manager.empty_assets.message_1',{
                    entity : 'media'
                    })}}
                  </div>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
       </template>

    </v-card-text>
    <!-- Preview Player -->
    <v-container class="pa-0" v-if="media_preview.showPreview">
      <v-dialog max-width="55vmin" v-model="media_preview.showPreview" persistent>
        <v-card>
          <v-card-title>
            <div class="title">Watch Trailer</div>
            <v-spacer></v-spacer>
            <v-btn
              small
              dark
              icon
              color="grey"
              @click="media_preview.showPreview = false"
              class="mx-0"
            >
              <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <ScreenerPlayer :movie="media_preview.url"></ScreenerPlayer>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <ImportFilms
    :importDialog.sync="importDialog"
    ></ImportFilms>
  </v-card>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import CreateFilm from "./CreateFilm";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import MediaPreview from "@/components/media/MediaPreview";
import ImportFilms from "@/components/film/ImportFilms"
import i18n from "@/i18n";
import DEFINES from "@/defines";
import moment from "moment";
import ScreenerPlayer from "@/components/screener/Player";

export default {
  name: "FilmOverview",
  components: {
    ConfirmationDialog,
    CreateFilm,
    MediaPreview,
    ImportFilms,
    ScreenerPlayer
  },
  data() {
    return {
      moment,
      search: "",
      media_preview: {
        url: null,
        showPreview: false
      },
      rowsPerPageItems: [10],
      table_headers: [
        {
          text: i18n.t("rms.table.header.media_id"),
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: i18n.t("rms.table.header.thumbnail"),
          align: "left",
          sortable: false,
          value: "thumbnail"
        },
        {
          text: i18n.t("rms.table.header.title"),
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: i18n.t("rms.table.header.streaming"),
          align: "left",
          sortable: false,
          value: "is_external_src"
        },
        {
          text: i18n.t('screener.encoding_status'),
          align: "left",
          sortable: false,
          value: "encoding_status"
        },
        {
          text: i18n.t("rms.table.header.length"),
          align: "left",
          sortable: false,
          value: "length"
        },
        {
          text: i18n.t("rms.table.header.right_holder_share"),
          align: "left",
          sortable: true,
          value: "right_holder_share"
        },
        {
          text: i18n.t("rms.table.header.created_on"),
          sortable: true,
          value: "created_at"
        },
        {
          text: i18n.t("rms.table.header.action"),
          sortable: false,
          align: "center",
          value: "action"
        }
      ],
      pagination: { sortBy: "created_at", descending: true, rowsPerPage: 10 },
      total: 0,
      importDialog:false
    };
  },

  watch: {
    pagination: {
      handler: "getApiData",
      deep: true
    },
    search: function(newValue, oldValue) {
      if(newValue == ""){
        this.clearSearch();
      }
    }
  },

  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected"
    }),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
    ...mapState({
      list: state => state.film.list
    }),
    currentLocale() {
      return this.$i18n.locale;
    }
  },

  mounted(){
    this.getApiData();
  },

  methods: {
    applySearch() {
      this.getApiData();
    },
    clearSearch() {
      this.search = "";
      this.getApiData();
    },

    async getApiData() {
      try {

        const { sortBy, descending, page } = this.pagination;

        // Payload
        let payload = {
          page : page,
          search: this.search,
          sort_by: {
            by: sortBy,
            dir: descending
          }
        };
        var result = await this.$store.dispatch("film/list", payload);
        this.total = result.films.total;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    async onDelete(film_id) {
      try {
        await this.$store.dispatch("film/delete", {
          id: film_id
        });
        await this.$store.dispatch("film/list");
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.deleted"),
          color: DEFINES.SNACKBAR_SUCCESS_COLOR
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    async view(film) {
      try {
        this.$router.push({
          name: "Film",
          params: {
            company_id: this.selected_company_id,
            film_id: film.id
          }
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    getDialogAction(update_status, btn_icon, btn_color) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        method: this.onDelete,
        payload: update_status
      };
    },
    watchTrailer(media) {
      this.media_preview.url = media.trailer;
      this.media_preview.showPreview = true;
    },
    closeTrailer() {
      this.media_preview.url = null;
      this.media_preview.showPreview = false;
    },
    initiateImport(){
      this.importDialog = true;
    },
  }
};
</script>
<style scoped>
.media_file_container {
  height: 100%;
  position: relative;
  width: 100%;
  background-color: #e2e2e2;
}
.hover-effect:hover {
  border-bottom: 1px solid;
}
</style>

